<script>
  import { Router, Link, Route, link, navigate } from "svelte-routing";
  import { onMount } from "svelte";
  import AvailableCoupons from "./available-coupons.svelte";

  const user = localStorage.getItem("us");

  onMount(() => {
    window.scrollTo(0, 0);

    if (user === null || user === "") {
      navigate("/login");
    }
  });

  const API_END_POINT = END_POINT;
  const cart_api_url = API_END_POINT + "getcart.php";
  const cart_final_price = API_END_POINT + "get_final_price.php";
  const cart_avail_api_url = API_END_POINT + "getcartavailability.php";
  const delete_cart_api_url = API_END_POINT + "delete_from_cart.php";
  const applycoupon_api_url = API_END_POINT + "applycoupon.php";

  $: coupon_status_value = "";
  let iscart_empty = "";
  let isquanity_avail = "";
  let isupdated = "";
  let showcheckout;
  let coupon_code,
    coupon_percent,
    totalprice,
    deliveryprice,
    finalamout = "";

  let getcart_details = [];

  let getcoupon_set_details = [];

  onMount(() => {
    get_my_cart();
  });

  async function get_my_cart() {
    const get_cart_response = await fetch(cart_api_url, {
      method: "POST",
      body: JSON.stringify({ uid: user }),
    });
    const cart_list_data = await get_cart_response.json();
    getcart_details = cart_list_data[0];
    isquanity_avail = cart_list_data[1].isallavailable;
    isupdated = cart_list_data[2].isset;

    getprices();

    if (getcart_details.length != 0) {
      iscart_empty = false;
    } else {
      iscart_empty = true;
    }

    if (isquanity_avail === "yes") {
      showcheckout = true;
    } else if (isquanity_avail === "no") {
      showcheckout = false;
    } else {
      showcheckout = undefined;
    }
    // console.log(showcheckout);
  }

  async function getprices() {
    if (isupdated == "yes") {
      const get_price_value = await fetch(cart_final_price, {
        method: "POST",
        body: JSON.stringify({ uid: user }),
      });
      const price_list_data = await get_price_value.json();
      coupon_code = price_list_data[0].coupon_code;
      coupon_percent = price_list_data[0].coupon_percent;
      totalprice = price_list_data[0].mrp;
      deliveryprice = price_list_data[0].delivery;
      finalamout = price_list_data[0].final_total;
    }
  }

  function CHide_Delete_Modal() {
    // to hide delete modal
    var cmodalInstance = null;
    var cmodelElem = document.getElementById("delete_from_cart_modal");
    cmodalInstance = bootstrap.Modal.getInstance(cmodelElem);
    cmodalInstance.hide();
    get_my_cart();
  }

  function CHide_Coupon_Modal() {
    // to hide delete modal
    var comodalInstance = null;
    var comodelElem = document.getElementById("Coupon_status");
    comodalInstance = bootstrap.Modal.getInstance(comodelElem);
    comodalInstance.hide();
    // window.location.reload();
  }

  async function delete_from_cart(wid) {
    const delete_from_cart_response = await fetch(delete_cart_api_url, {
      method: "POST",
      body: JSON.stringify({ uid: user, wid: wid }),
    });
    const delete_from_cart_data = delete_from_cart_response.json();
    if ((delete_from_cart_data.isdeleted = "yes")) {
      let Delete_Modal = new bootstrap.Modal(
        document.getElementById("delete_from_cart_modal"),
        {}
      );
      Delete_Modal.show();
      setTimeout(CHide_Delete_Modal, 2000);
    }
  }

  function remove_placeholder() {
    const nodeList = document.querySelectorAll(".placeholder");
    for (var i = 0; i < nodeList.length; i++) {
      nodeList[i].classList.remove("placeholder");
    }
  }

  async function applycoupon() {
    let apply_coupon_code = document.getElementById("apply_coupon_code").value;

    if (!apply_coupon_code) {
      alert("Enter a Coupon Code");
    } else {
      const apply_coupon_code_response = await fetch(applycoupon_api_url, {
        method: "POST",
        body: JSON.stringify({
          uid: user,
          cid: apply_coupon_code,
          amount: finalamout,
        }),
      });
      const apply_coupon_code_data = await apply_coupon_code_response.json();
      getcoupon_set_details = apply_coupon_code_data;
      // console.log(getcoupon_set_details);

      if (getcoupon_set_details.isupdated_new == true) {
        console.log(getcoupon_set_details.isupdated_new);
        getprices();
      } else {
        // console.log(apply_coupon_code_data.status);

        coupon_status_value = apply_coupon_code_data.status;
        let Coupon_Modal = new bootstrap.Modal(
          document.getElementById("Coupon_status"),
          {}
        );
        Coupon_Modal.show();
        setTimeout(CHide_Coupon_Modal, 5000);
      }
    }
  }
</script>

<svelte:head>
  <title>Cart | Veeranfashions Home</title>
</svelte:head>

<main class="main-wrapper">
  <!-- ...:::Start User Event Section:::... -->
  <div class="header-section">
    <div class="container">
      <!-- Start User Event Area -->
      <div class="header-area">
        <div class="header-top-area header-top-area--style-1">
          <ul class="event-list">
            <li class="list-item">
              <span
                onclick="goback()"
                area-label="mobile menu offcanvas svg icon"
                class="btn btn--size-33-33 btn--center btn--round btn--color-radical-red btn--bg-white btn--box-shadow main-menu offcanvas-toggle offside-menu"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  class="bi bi-caret-left-fill"
                  viewBox="0 0 16 16"
                >
                  <path
                    d="m3.86 8.753 5.482 4.796c.646.566 1.658.106 1.658-.753V3.204a1 1 0 0 0-1.659-.753l-5.48 4.796a1 1 0 0 0 0 1.506z"
                  />
                </svg>
              </span>
            </li>
            <li class="list-item">
              <h2 class="title text-center">Cart</h2>
            </li>
            <li class="list-item">
              <ul class="list-child">
                <li class="list-item">
                  <span class="notch-bg" />
                  <Link
                    to="wishlist"
                    area-label="wishlist"
                    class="btn btn--size-33-33 btn--center btn--round btn--color-radical-red btn--bg-white btn--box-shadow"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      class="bi bi-heart-fill"
                      viewBox="0 0 16 16"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M8 1.314C12.438-3.248 23.534 4.735 8 15-7.534 4.736 3.562-3.248 8 1.314z"
                      />
                    </svg>
                  </Link>
                </li>
                <li class="list-item">
                  <span class="notch-bg" />
                  <Link
                    to="/profile-settings"
                    area-label="Cart"
                    class="btn btn--size-33-33 btn--center btn--round btn--color-radical-red btn--bg-white btn--box-shadow"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      class="bi bi-person-fill"
                      viewBox="0 0 16 16"
                    >
                      <path
                        d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H3zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"
                      />
                    </svg>
                  </Link>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
      <!-- End User Event Area -->
    </div>
  </div>
  <!-- ...:::End User Event Section:::... -->

  <!-- ...:::Start Whishlist Section:::... -->
  <div class="cart-section section-gap-top-30">
    <div class="container">
      <div class="cart-items-wrapper">
        <ul class="cart-item-list">
          {#each getcart_details as getcart_detail}
            <!-- Start Single Cart Item -->
            <li class="single-cart-item">
              <div class="image placeholder-glow">
                <picture>
                  <source
                    srcset="https://imagecdn.veeranfashions.com/webp/{getcart_detail.product_image.replace(
                      'png',
                      'webp'
                    )}"
                    type="image/webp"
                    alt="product"
                  />
                  <source
                    srcset="https://imagecdn.veeranfashions.com/{getcart_detail.product_image}"
                    type="image/png"
                  />
                  <img
                    width="90"
                    height="90"
                    src="https://imagecdn.veeranfashions.com/{getcart_detail.product_image}"
                    alt=""
                    class="placeholder"
                    on:load={remove_placeholder}
                  />
                </picture>
              </div>
              <div class="content">
                <div class="details">
                  <div class="left">
                    <Link
                      to="/product/{getcart_detail.product_id}"
                      class="title"
                      >{getcart_detail.product_name}
                    </Link>
                  </div>
                  <div class="right">
                    <h6 class="text-pink">
                      Size : {getcart_detail.product_size}
                    </h6>
                  </div>
                </div>
                <div class="details">
                  <div class="left">
                    <div class="product-quantity text-pink">
                      Stock : {getcart_detail.isavail}
                    </div>
                  </div>
                  <div class="right">
                    <div class="product-quantity">
                      <div class="num-block skin-2 text-pink">
                        Qty:{getcart_detail.quantity}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="details pt-2">
                  <div class="left">
                    <button
                      on:click={delete_from_cart(getcart_detail.nos)}
                      class="btn btn-sm btn-submit"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-trash-fill"
                        viewBox="0 0 16 16"
                      >
                        <path
                          d="M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1H2.5zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5zM8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5zm3 .5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 1 0z"
                        />
                      </svg>
                    </button>
                  </div>
                  <div class="right">
                    <div class="product-quantity">
                      <div class="num-block skin-2 text-pink">
                        ₹ {getcart_detail.price}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </li>
          {/each}
          <!-- End Single Cart Item -->
        </ul>

        {#if showcheckout}
          <ul class="cart-info-list">
            <li class="cart-info-single-list">
              {#if !coupon_code && coupon_percent == "0"}
                <div class="row">
                  <div class="col-6 pt-3 pb-3">
                    <input
                      type="text"
                      placeholder="Apply Coupon Code"
                      class="form-control"
                      name="apply_coupon_code"
                      id="apply_coupon_code"
                    />
                  </div>
                  <div class="col-6 pt-3 pb-3">
                    <button class="button-login" on:click={applycoupon}
                      >Apply Coupon</button
                    >
                  </div>
                </div>
              {/if}
              <ul class="cart-info-child">
                <li class="item">
                  <span class="text-left">Total MRP</span>
                  <span class="text-colored">₹ {totalprice}</span>
                </li>
                <li class="item">
                  <span class="text-left">Delivery </span>
                  <span class="text-colored">₹ {deliveryprice}</span>
                </li>
                {#if coupon_code}
                  <li class="item">
                    <span class="text-left">Coupon</span>
                    <span class="text-colored">{coupon_code}</span>
                  </li>
                {/if}
                {#if coupon_percent != "0"}
                  <li class="item">
                    <span class="text-left">Discount</span>
                    <span class="text-colored">{coupon_percent} % </span>
                  </li>
                {/if}
                <li class="item">
                  <span class="text-left">Total</span>
                  <span class="text-colored">₹ {finalamout}</span>
                </li>
              </ul>
            </li>
          </ul>
        {/if}
      </div>
      {#if !iscart_empty}
        {#if showcheckout}
          <div class="pt-3 pb-3">
            <Link to="checkout" class="button-login">Checkout</Link>
          </div>
          {#if !coupon_code}
            <div class="pt-1 pb-3">
              <Link to="/available-coupons">
                Click Here See Available Coupons
              </Link>
            </div>
          {/if}
        {:else if showcheckout === false}
          <div class="my-3 mx-5 pt-3 text-colored">
            Some of the products in your cart 🛒 is currently out of stock 😟.<br
            /> So please delete that product from cart and buy other products.
          </div>
        {/if}
      {:else}
        <div class="profile-card-section section-gap-top-25">
          <div class="profile-card-wrapper">
            <div class="content">
              <h2 class="setting-name text-white text-center">
                😟 No Products in Cart 💔
              </h2>
            </div>
            <div class="profile-shape profile-shape-1">
              <img
                class="img-fluid"
                src="assets/images/profile-shape-1.svg"
                alt=""
                width="61"
                height="50"
              />
            </div>
            <div class="profile-shape profile-shape-2">
              <img
                class="img-fluid"
                src="assets/images/profile-shape-2.svg"
                alt=""
                width="48"
                height="59"
              />
            </div>
          </div>
        </div>
      {/if}
    </div>
  </div>
  <!-- ...:::End Whishlist Section:::... -->

  <!-- ...:::Start User Event Section:::... -->
  <div class="user-event-section">
    <!-- Start User Event Area -->
    <div class="col pos-relative">
      <div class="user-event-area">
        <div class="nav">
          <Link to="/" class="nav__link">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              fill="currentColor"
              class="bi bi-house-fill"
              viewBox="0 0 16 16"
            >
              <path
                fill-rule="evenodd"
                d="m8 3.293 6 6V13.5a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 2 13.5V9.293l6-6zm5-.793V6l-2-2V2.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5z"
              />
              <path
                fill-rule="evenodd"
                d="M7.293 1.5a1 1 0 0 1 1.414 0l6.647 6.646a.5.5 0 0 1-.708.708L8 2.207 1.354 8.854a.5.5 0 1 1-.708-.708L7.293 1.5z"
              />
            </svg>
            <br />
            <h6>Home</h6>
          </Link>
          <Link to="/wishlist" class="nav__link">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              fill="currentColor"
              class="bi bi-heart-fill"
              viewBox="0 0 16 16"
            >
              <path
                fill-rule="evenodd"
                d="M8 1.314C12.438-3.248 23.534 4.735 8 15-7.534 4.736 3.562-3.248 8 1.314z"
              />
            </svg>
            <br />
            <h6>Wishlist</h6>
          </Link>
          <Link to="/shop" class="nav__link">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              fill="currentColor"
              class="bi bi-grid-fill"
              viewBox="0 0 16 16"
            >
              <path
                d="M1 2.5A1.5 1.5 0 0 1 2.5 1h3A1.5 1.5 0 0 1 7 2.5v3A1.5 1.5 0 0 1 5.5 7h-3A1.5 1.5 0 0 1 1 5.5v-3zm8 0A1.5 1.5 0 0 1 10.5 1h3A1.5 1.5 0 0 1 15 2.5v3A1.5 1.5 0 0 1 13.5 7h-3A1.5 1.5 0 0 1 9 5.5v-3zm-8 8A1.5 1.5 0 0 1 2.5 9h3A1.5 1.5 0 0 1 7 10.5v3A1.5 1.5 0 0 1 5.5 15h-3A1.5 1.5 0 0 1 1 13.5v-3zm8 0A1.5 1.5 0 0 1 10.5 9h3a1.5 1.5 0 0 1 1.5 1.5v3a1.5 1.5 0 0 1-1.5 1.5h-3A1.5 1.5 0 0 1 9 13.5v-3z"
              />
            </svg>
            <br />
            <h6>Shop</h6>
          </Link>
          
          <Link to="/orders" class="nav__link">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              fill="currentColor"
              class="bi bi-box-seam-fill"
              viewBox="0 0 16 16"
            >
              <path
                fill-rule="evenodd"
                d="M15.528 2.973a.75.75 0 0 1 .472.696v8.662a.75.75 0 0 1-.472.696l-7.25 2.9a.75.75 0 0 1-.557 0l-7.25-2.9A.75.75 0 0 1 0 12.331V3.669a.75.75 0 0 1 .471-.696L7.443.184l.01-.003.268-.108a.75.75 0 0 1 .558 0l.269.108.01.003 6.97 2.789ZM10.404 2 4.25 4.461 1.846 3.5 1 3.839v.4l6.5 2.6v7.922l.5.2.5-.2V6.84l6.5-2.6v-.4l-.846-.339L8 5.961 5.596 5l6.154-2.461L10.404 2Z"
              />
            </svg>
            <br />
            <h6>Orders</h6>
          </Link>
          
          <Link to="/settings" class="nav__link">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              fill="currentColor"
              class="bi bi-gear-fill"
              viewBox="0 0 16 16"
            >
              <path
                d="M9.405 1.05c-.413-1.4-2.397-1.4-2.81 0l-.1.34a1.464 1.464 0 0 1-2.105.872l-.31-.17c-1.283-.698-2.686.705-1.987 1.987l.169.311c.446.82.023 1.841-.872 2.105l-.34.1c-1.4.413-1.4 2.397 0 2.81l.34.1a1.464 1.464 0 0 1 .872 2.105l-.17.31c-.698 1.283.705 2.686 1.987 1.987l.311-.169a1.464 1.464 0 0 1 2.105.872l.1.34c.413 1.4 2.397 1.4 2.81 0l.1-.34a1.464 1.464 0 0 1 2.105-.872l.31.17c1.283.698 2.686-.705 1.987-1.987l-.169-.311a1.464 1.464 0 0 1 .872-2.105l.34-.1c1.4-.413 1.4-2.397 0-2.81l-.34-.1a1.464 1.464 0 0 1-.872-2.105l.17-.31c.698-1.283-.705-2.686-1.987-1.987l-.311.169a1.464 1.464 0 0 1-2.105-.872l-.1-.34zM8 10.93a2.929 2.929 0 1 1 0-5.86 2.929 2.929 0 0 1 0 5.858z"
              />
            </svg>
            <br />
            <h6>Settings</h6>
          </Link>
        </div>
      </div>
    </div>
    <!-- End User Event Area -->
  </div>
  <!-- ...:::End User Event Section:::... -->

  <div class="modal slide-top" tabindex="-1" id="delete_from_cart_modal">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content text-center glass">
        <div class="modal-header">
          <h5 class="modal-title">Veeranfashions</h5>
        </div>
        <div class="modal-body">
          <p>Product Deleted from Cart.</p>
        </div>
      </div>
    </div>
  </div>

  <div class="modal slide-top" tabindex="-1" id="Coupon_status">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content text-center glass">
        <div class="modal-header">
          <h5 class="modal-title">Veeranfashions</h5>
        </div>
        <div class="modal-body">
          <p>{coupon_status_value}</p>
        </div>
      </div>
    </div>
  </div>

  <footer class="footer-section" />
</main>
